import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import store from '../store';
import { setStorageSize, setStorageType } from '../store/bookingSlice';

import classes from './JourneyProgress.module.scss';

interface Props {
    to?: string;
    label: string;
    active: number;
    step: number;
}

function JourneyStep({ label, to, active, step }: Props) {
    const navigate = useNavigate();

    const className = useMemo(() => {
        if (active === step) {
            return classes.active;
        }
        if (active > step) {
            return classes.complete;
        }

        return classes.normal;
    }, [active, step]);

    const goTo = () => {
        if (!to) {
            return;
        }
        if (label === 'Location') {
            store.dispatch(setStorageSize(null));
            store.dispatch(setStorageType(null));
        }
        navigate(to);
    };

    return (
        <div
            className={`
			${className} ${classes.step}
		`}
            onClick={goTo}
        >
            <span>{step}</span>
            <span>{label}</span>
        </div>
    );
}

export default JourneyStep;
